import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, InputWithIcon, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Menu, Divider,
// ListSubheader,
Typography, TextField, MenuItem, Checkbox, ListItemText } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { PROPERTY_STATUS_FILTER_OPTIONS, PROPERTY_STATUS_LABEL_KEYS } from 'src/constants/property';
import useStyles from './styles';
export const PortfolioNavFilterMenu = observer(_ref => {
  var _store$homeDashboardS6, _store$homeDashboardS7, _store$homeDashboardS8, _store$homeDashboardS9, _store$homeDashboardS0, _store$homeDashboardS10, _store$homeDashboardS12, _store$homeDashboardS13;
  let isNavOpen = _ref.isNavOpen,
    listItems = _ref.listItems,
    menuTriggerExternal = _ref.menuTriggerExternal;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState('root'),
    _useState2 = _slicedToArray(_useState, 2),
    level = _useState2[0],
    setLevel = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setLevel('root');
  };
  const MenuTriggerInternal = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t('general.to_do')), /*#__PURE__*/React.createElement(Icon, {
      type: "triangle-down"
    }));
  };
  const SecondFilterLevel = observer(_ref2 => {
    let portfolioList = _ref2.portfolioList,
      resetSearchTrigger = _ref2.resetSearchTrigger,
      closeSecondLevel = _ref2.closeSecondLevel,
      handleCloseMenu = _ref2.handleCloseMenu;
    const _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      searchKey = _useState6[0],
      setSearchKey = _useState6[1];
    const handleSearchKeyChange = e => {
      setSearchKey(e.target.value);
    };
    const getListItems = () => {
      return portfolioList.filter(i => {
        const searchPhrase = new RegExp(searchKey, 'gi');
        return searchKey.length > 0 ? " ".concat(i.name).search(searchPhrase) > 0 : true;
      });
    };
    useEffect(() => {
      setSearchKey('');
    }, [resetSearchTrigger]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "menuAction",
      className: classes.returnFromSecondFilterLevel,
      onClick: event => {
        event.stopPropagation();
        closeSecondLevel();
      },
      'custom-attribute': '369-PortfolioNavFilterMenu'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-down",
      state: "dark"
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, 'Filter by portfolio')), /*#__PURE__*/React.createElement("div", {
      className: classes.searchField
    }, /*#__PURE__*/React.createElement(InputWithIcon, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "search"
      })
    }, /*#__PURE__*/React.createElement(TextField, {
      variant: "outlined",
      fullWidth: true,
      placeholder: t('general.search'),
      value: searchKey,
      onChange: handleSearchKeyChange
    }))), /*#__PURE__*/React.createElement(Divider, {
      className: classes.dividerNoBottomMargin
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.filterMultiselectContainer
    }, getListItems().map(item => {
      var _store$homeDashboardS2;
      return /*#__PURE__*/React.createElement(MenuItem, {
        className: classes.filterMultiselectItem,
        key: item.id,
        value: item.id,
        variant: "multiple",
        onClick: event => {
          var _store$homeDashboardS;
          event.stopPropagation();
          event.stopPropagation();
          if (item.properties.length !== 0) (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || _store$homeDashboardS.portfolioNavOptions.toggleItemSelection(item.id);
        },
        'custom-attribute': '370-PortfolioNavFilterMenu'
      }, /*#__PURE__*/React.createElement(Checkbox, {
        disabled: item.properties.length === 0 ? true : false,
        checked: (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.portfolioNavOptions.isItemSelected(item.id)
      }), /*#__PURE__*/React.createElement(ListItemText, {
        primary: item.name + (item.properties.length === 0 ? ' (' + t('team_page.no_properties') + ')' : '')
      }));
    })), /*#__PURE__*/React.createElement(Divider, {
      className: classes.dividerNoTopMargin
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.secondLevelActionBtns
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      size: "small",
      className: classes.sortAscOption,
      onClick: event => {
        var _store$homeDashboardS3;
        event.stopPropagation();
        (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 || _store$homeDashboardS3.portfolioNavOptions.resetFilterOptions();
      },
      'custom-attribute': '371-PortfolioNavFilterMenu'
    }, 'Reset'), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      size: "small",
      className: classes.sortAscOption,
      onClick: event => {
        event.stopPropagation();
        handleCloseMenu();
        console.log('2nd Level apply clicked');
      },
      'custom-attribute': '372-PortfolioNavFilterMenu'
    }, 'Close')));
  });
  const StatusFilterLevel = observer(_ref3 => {
    var _store$homeDashboardS4;
    let portfolioList = _ref3.portfolioList,
      closeStatusLevel = _ref3.closeStatusLevel,
      handleCloseMenu = _ref3.handleCloseMenu;
    const _useState7 = useState(((_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.portfolioNavOptions.statusFilter.slice()) || []),
      _useState8 = _slicedToArray(_useState7, 2),
      draft = _useState8[0],
      setDraft = _useState8[1];
    const statusCounts = (portfolioList || []).flatMap(portfolio => {
      var _portfolio$properties;
      return ((_portfolio$properties = portfolio.properties) === null || _portfolio$properties === void 0 ? void 0 : _portfolio$properties.slice()) || [];
    }).reduce((acc, property) => {
      var _property$dashboard;
      const status = property === null || property === void 0 || (_property$dashboard = property.dashboard) === null || _property$dashboard === void 0 ? void 0 : _property$dashboard.propertyStatus;
      if (status) acc[status] = (acc[status] || 0) + 1;
      return acc;
    }, {});
    const toggleDraft = status => setDraft(current => current.includes(status) ? current.filter(i => i !== status) : [...current, status]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "menuAction",
      className: classes.returnFromSecondFilterLevel,
      onClick: event => {
        event.stopPropagation();
        closeStatusLevel();
      },
      'custom-attribute': '380-PortfolioNavFilterMenu'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-down",
      state: "dark"
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, t('general.filter_by_status'))), /*#__PURE__*/React.createElement(Divider, {
      className: classes.dividerNoBottomMargin
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.statusFilterContainer
    }, PROPERTY_STATUS_FILTER_OPTIONS.map(status => {
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: status,
        value: status,
        variant: "multiple",
        onClick: event => {
          event.stopPropagation();
          toggleDraft(status);
        },
        'custom-attribute': '381-PortfolioNavFilterMenu'
      }, /*#__PURE__*/React.createElement(Checkbox, {
        checked: draft.includes(status)
      }), t(PROPERTY_STATUS_LABEL_KEYS[status]), /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        color: "primary",
        className: classes.statusFilterCount
      }, statusCounts[status] || 0));
    })), /*#__PURE__*/React.createElement(Divider, {
      className: classes.dividerNoTopMargin
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.secondLevelActionBtns
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      size: "small",
      className: classes.sortAscOption,
      onClick: event => {
        event.stopPropagation();
        closeStatusLevel();
      },
      'custom-attribute': '382-PortfolioNavFilterMenu'
    }, 'Cancel'), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      size: "small",
      className: classes.sortAscOption,
      onClick: event => {
        var _store$homeDashboardS5;
        event.stopPropagation();
        (_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS5 === void 0 || _store$homeDashboardS5.portfolioNavOptions.setStatusFilter(draft);
        handleCloseMenu();
      },
      'custom-attribute': '383-PortfolioNavFilterMenu'
    }, 'Apply')));
  });
  return /*#__PURE__*/React.createElement("span", {
    onClick: e => e.stopPropagation(),
    onKeyDown: e => e.stopPropagation(),
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: t('general.sort_and_filter'),
    key: 'PortfolioNavFilterMenu' + ((_store$homeDashboardS6 = store.homeDashboardStore) === null || _store$homeDashboardS6 === void 0 ? void 0 : _store$homeDashboardS6.enableShortcutsHintState),
    placement: (_store$homeDashboardS7 = store.homeDashboardStore) !== null && _store$homeDashboardS7 !== void 0 && _store$homeDashboardS7.enableShortcutsHintState ? 'left' : 'top',
    type: "info",
    open: isNavOpen && ((_store$homeDashboardS8 = store.homeDashboardStore) === null || _store$homeDashboardS8 === void 0 ? void 0 : _store$homeDashboardS8.enableShortcutsHintState) || undefined
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    className: classes.filterDropdown,
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open || !((_store$homeDashboardS9 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS9 !== void 0 && _store$homeDashboardS9.portfolioNavOptions.isFilterDefault) ? 'active' : undefined,
    'custom-attribute': '373-PortfolioNavFilterMenu'
  }, menuTriggerExternal !== undefined ? menuTriggerExternal : /*#__PURE__*/React.createElement(MenuTriggerInternal, null))), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, level === 'status' ? /*#__PURE__*/React.createElement(StatusFilterLevel, {
    portfolioList: listItems,
    closeStatusLevel: () => setLevel('root'),
    handleCloseMenu: handleClose
  }) : level === 'root' ? /*#__PURE__*/React.createElement("div", null, ((_store$homeDashboardS0 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS0 === void 0 ? void 0 : _store$homeDashboardS0.portfolioNavOptions.selectedSortOrder) !== 'asc' && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    className: classes.sortAscOption,
    onClick: event => {
      var _store$homeDashboardS1;
      event.stopPropagation();
      (_store$homeDashboardS1 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS1 === void 0 || _store$homeDashboardS1.portfolioNavOptions.setSortOrder('asc');
      handleClose();
    },
    'custom-attribute': '374-PortfolioNavFilterMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, 'Sort ASC')), ((_store$homeDashboardS10 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS10 === void 0 ? void 0 : _store$homeDashboardS10.portfolioNavOptions.selectedSortOrder) !== 'desc' && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: event => {
      var _store$homeDashboardS11;
      event.stopPropagation();
      (_store$homeDashboardS11 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS11 === void 0 || _store$homeDashboardS11.portfolioNavOptions.setSortOrder('desc');
      handleClose();
    },
    'custom-attribute': '375-PortfolioNavFilterMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, 'Sort Desc')), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Button, {
    className: classes.filterByPortfoliosOption,
    variant: "menuAction",
    onClick: event => {
      event.stopPropagation();
      setLevel('status');
    },
    'custom-attribute': '384-PortfolioNavFilterMenu'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('general.filter_by_status'), ((_store$homeDashboardS12 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS12 === void 0 ? void 0 : _store$homeDashboardS12.portfolioNavOptions.statusFilter.length) > 0 && /*#__PURE__*/React.createElement("span", {
    className: classes.firstLevelFilterCount
  }, (_store$homeDashboardS13 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS13 === void 0 ? void 0 : _store$homeDashboardS13.portfolioNavOptions.statusFilter.length)), /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-right"
  }))) : /*#__PURE__*/React.createElement(SecondFilterLevel, {
    portfolioList: listItems,
    resetSearchTrigger: level === 'portfolios',
    closeSecondLevel: () => setLevel('root'),
    handleCloseMenu: handleClose
  })));
});